// extracted by mini-css-extract-plugin
export default {"reportSidebarWrapper":"index-module__reportSidebarWrapper--gCl6o","reportSidebar":"index-module__reportSidebar--Ag78a","overflowing":"index-module__overflowing--JUF_m"};